module.exports = __webpack_public_path__ + "img/waves-2.045e9795.webp";